import gql from 'graphql-tag';
export default gql`
  mutation submitWetSignature($applicationId: String!, $status: String!) {
    submitWetSignature(applicationId: $applicationId, status: $status) {
      url
    }
  }
`;
